import { type ReactNode } from 'react';
import './Field.css';

interface FieldProps {
  label: ReactNode;
  hint?: ReactNode;
  children: ReactNode;
  value?: ReactNode;
}

export function Field({ label, hint, value, children }: FieldProps) {
  return (
    <label className="field">
      <div className="field__row">
        <span className="field__label">{label}</span>
        {value !== undefined && <span className="field__value">{value}</span>}
      </div>
      {children}
      {hint && <span className="field__hint">{hint}</span>}
    </label>
  );
}
